import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: #000000;
  height: 100%;
`
